// Vue
import { Component, Watch } from "vue-property-decorator";
import { Observer } from "mobx-vue";
// Template
import template from "./template.vue";
// Base Module
import ModuleBase from "#/common/ModuleBase";
// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import { Api } from "#/api";
import { TableColumnOptions } from "@mgs/ci2019-common/src/interfaces/TableColumnOptions";
import {
  ResultData,
  SpecialEquipmentData,
  TableResult,
} from "#/common/models/module/SpecialEquipmentData";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class KbvFilterModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }

  private data: SpecialEquipmentData | null = null;
  private filter: object = {};
  private session: object = {};
  private isLoading: boolean = false;
  private isDownloading: boolean = false;
  private clear_select = "clear_select";

  @Watch("filter", { deep: true })
  onFilterChange() {
    Object.entries(this.filter).forEach(([key, value]) => {
      if (value === this.clear_select) {
        delete this.filter[key];
      }
    });
    this.loadData();
  }

  get selectFields() {
    if (this.data) {
      let merged = this.instance["filter"].map((item) => {
        if (this.data?.filterData[item.category_key].selected !== "") {
          this.data!.filterData[item.category_key].options[this.clear_select] =
            {
              code: this.clear_select,
              description: this.$t("KBV_FILTER_CLEAR_SELECT"),
            };
        }
        return { ...item, ...this.data?.filterData[item.category_key] };
      });
      merged = merged.filter((item) => item.options !== undefined);
      return merged;
    } else {
      return [];
    }
  }

  get resultType() {
    return this.instance["section_result"]["result_type"];
  }

  findGroupname(group: any) {
    if (!this.instance["section_result"]["groups"]) {
      return null;
    }
    for (let value of this.instance["section_result"]["groups"]) {
      if (value.id == group) {
        return value.description;
      }
    }
    return null;
  }

  get tableColumns() {
    let result: { [key: string]: TableColumnOptions & { tooltip: string } } =
      {};

    //Col 0 for download-links
    result[0] = { name: "", tooltip: "" };

    let lastgroup: string = "";
    let lastname: string[] = [];
    let lastdesc: string[] = [];
    let i = 1;
    this.instance["section_result"]["result_fields"].forEach((value: any) => {
      if (value.grouping !== undefined && value.grouping !== "") {
        let groupname: string | null = this.findGroupname(value.grouping);
        console.log(groupname);
        if (lastgroup !== value.grouping) {
          if (lastgroup !== "") {
            result[i] = {
              name: lastname.join("<br>"),
              tooltip: lastdesc.join("<br>"),
            };
            i++;
            lastdesc = [];
            lastname = [];
          }
          lastgroup = value.grouping;
          if (groupname === null) {
            if (value.abbreviation) {
              lastname.push(value.abbreviation);
            }
          } else {
            lastname = [groupname];
          }
          if (value.description) {
            lastdesc = [value.description];
          }
        } else {
          if (groupname === null && value.abbreviation) {
            lastname.push(value.abbreviation);
          }
          if (value.description) {
            lastdesc.push(value.description);
          }
        }
      } else {
        //No Group, always a new column
        if (lastgroup !== "") {
          result[i] = {
            name: lastname.join("<br>"),
            tooltip: lastdesc.join("<br>"),
          };
          i++;
          lastdesc = [];
          lastname = [];
        }
        lastgroup = "-"; //Set sonething different than "" to know we have to add the group
        lastname = [value.abbreviation];
        if (value.description) {
          lastdesc = [value.description];
        }
        if (value.properties !== undefined && Array.isArray(value.properties)) {
          value.properties.forEach((prop: any) => {
            if (prop.description) {
              lastdesc.push(prop.description);
            }
          });
        }
      }
    });
    if (lastgroup !== "") {
      result[i] = {
        name: lastname.join("<br>"),
        tooltip: lastdesc.join("<br>"),
      };
    }
    console.log(result);
    return result;
  }

  findValueforTable(config: any, entry: ResultData): string {
    if (!entry) {
      return "";
    }
    if (config.typ === "model") {
      return entry.model;
    }
    if (!Array.isArray(entry.data) || entry.data.length === 0) {
      return "";
    }
    for (let value of entry.data) {
      if (value.id == config.id && value.type === config.typ) {
        let result = value.value;
        if (value.properties !== undefined) {
          //poperties here is an object not an array...
          for (const k in value.properties) {
            if (value.properties[k]) {
              result += "<br>" + value.properties[k];
            }
          }
        }
        return result;
      }
    }
    return "";
  }

  get tableData() {
    if (
      !this.data ||
      !Array.isArray(this.data.resultData) ||
      this.data.resultData.length === 0
    ) {
      return [];
    }

    let result: any[] = [];

    this.data.resultData.forEach((entry) => {
      let row = {};
      //Col 0 for download-links
      row[0] = { model: entry.model, code: entry.code };
      let lastgroup: string = "";
      let lastvalue: string[] = [];
      let i = 1;
      this.instance["section_result"]["result_fields"].forEach((value: any) => {
        //Find value
        let curvalue = this.findValueforTable(value, entry);

        //find place to add
        if (value.grouping !== undefined) {
          if (lastgroup !== value.grouping) {
            if (lastgroup !== "") {
              row[i] = lastvalue.join("<br>");
              i++;
            }
            lastgroup = value.grouping;
            //Find value
            lastvalue = [curvalue];
          } else {
            lastvalue.push(curvalue);
          }
        } else {
          //No Group, always a new column
          if (lastgroup !== "") {
            row[i] = lastvalue.join("<br>");
            i++;
          }
          lastgroup = "-";
          lastvalue = [curvalue];
        }
      });
      if (lastgroup !== "") {
        row[i] = lastvalue.join("<br>");
      }

      result.push(row);
    });
    console.log(result);
    return result;
  }

  findValueforTile(config: any, entry: TableResult[]): TableResult | null {
    if (!entry || !Array.isArray(entry) || entry.length === 0) {
      return null;
    }
    for (let value of entry) {
      if (value.id == config.id && value.type === config.typ) {
        return value;
      }
    }
    return null;
  }

  get groupedData() {
    if (
      !this.data ||
      !Array.isArray(this.data.resultData) ||
      this.data.resultData.length === 0
    ) {
      return [];
    }

    let result: any[] = [];
    this.data.resultData.forEach((entry) => {
      let lastgroup: string = "";
      let curgroup: any = { name: "", entries: [] };
      //Go through config and create groups
      this.instance["section_result"]["result_fields"].forEach(
        (config: any) => {
          let name = "";
          let props: any = undefined;
          if (config.typ === "model") {
            name = entry.model;
          } else {
            let val = this.findValueforTile(config, entry.data);
            if (val !== null) {
              name = val.value;
              if (val.description !== undefined && val.description) {
                name += ": " + val.description;
              }
              props = val.properties;
            }
          }

          if (name !== "") {
            if (config.grouping !== undefined && config.grouping !== "") {
              if (lastgroup !== "" && lastgroup !== config.grouping) {
                result.push(curgroup);
                curgroup = { name: "", entries: [] };
              }
              lastgroup = config.grouping;
              let groupname: string | null = this.findGroupname(
                config.grouping
              );
              if (groupname !== null) {
                curgroup.name = groupname;
              }
              curgroup.entries.push({
                value: name,
                description: config.description,
              });
            } else {
              if (lastgroup !== "") {
                result.push(curgroup);
                curgroup = { name: "", entries: [] };
              }
              lastgroup = "-";
              curgroup.name = name;
              if (props !== undefined) {
                //poperties here is an object not an array...
                for (const [key, prop] of Object.entries(props)) {
                  if (prop) {
                    let desc = "";
                    config.properties.forEach((p: any) => {
                      if (p.id == key) {
                        desc = p.description;
                        return;
                      }
                    });
                    curgroup.entries.push({ value: prop, description: desc });
                  }
                }
              }
            }
          }
        }
      );
      result.push(curgroup);
      //Add Group for Drawings
      result.push({
        name: "Zeichnungsgenerierung",
        entries: [
          {
            button: true,
            description: "DXF",
            type: "dxf",
            data: { model: entry.model, code: entry.code },
          },
          {
            button: true,
            description: "PDF",
            type: "pdf",
            data: { model: entry.model, code: entry.code },
          },
        ],
      });
    });
    return result;
  }

  public created() {
    this.loadData();
  }

  public async loadData() {
    const urlParams = new URLSearchParams(window.location.search);
    let token = urlParams.get("token");

    if (token && !this.isLoading) {
      this.isLoading = true;

      let filterGroups = this.instance["filter"].map(
        (filter: any) => filter.category_key
      );
      let resultConfig = this.instance["section_result"]["result_fields"];

      this.data = await Api.katalogService.getSpecialEquipment(
        filterGroups,
        Object.keys(this.filter).length > 0 ? this.filter : undefined,
        resultConfig,
        token
      );
      this.isLoading = false;
    }
  }

  getSelectLabel(option: any) {
    if (option.code == this.clear_select || option.code == "") {
      return option.description;
    }
    return option.code + ": " + option.description;
  }
  getPlaceholderForSelectfield(field: { options: object }) {
    if (Object.values(field.options).length === 1) {
      let option = Object.values(field.options)[0];
      if (option.code == this.clear_select || option.code == "") {
        return option.description;
      }
      return option.code + ": " + option.description;
    } else {
      return undefined;
    }
  }

  onResetFilter(key) {
    if (this.filter[key]) {
      delete this.filter[key];
      this.data = null;
      this.onFilterChange();
    }
  }

  async onDownloadClick(value: any, type: string) {
    this.isDownloading = true;
    //await Api.katalogService.downloadDrawing(value.model, value.code, type);
    this.isDownloading = false;
  }
}
